function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 10a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm5.629-10a2.25 2.25 0 011.59.659l2.812 2.81 2.808 2.812c.421.422.658.994.658 1.59v9.879a2.25 2.25 0 01-2.25 2.25H10.19c.426-.443.79-.948 1.077-1.499l5.48-.001a.75.75 0 00.75-.75l-.001-9.747H13.25a2.25 2.25 0 01-2.245-2.095L11 5.754 10.999 1.5H5.25a.75.75 0 00-.75.75v6.827a6.454 6.454 0 00-1.5.422V2.25A2.25 2.25 0 015.25 0h5.879zM3.093 12.966l-.07.058-.057.07a.5.5 0 000 .568l.058.07 1.77 1.769-1.768 1.766-.057.07a.5.5 0 000 .568l.057.07.07.057a.5.5 0 00.568 0l.07-.057L5.5 16.208l1.77 1.769.069.058a.5.5 0 00.568 0l.07-.058.057-.07a.5.5 0 000-.568l-.058-.07-1.769-1.768 1.772-1.77.058-.069a.5.5 0 000-.569l-.058-.069-.069-.058a.5.5 0 00-.569 0l-.069.058-1.772 1.77-1.77-1.77-.068-.058a.5.5 0 00-.569 0zM12.5 2.56l.001 3.195c0 .38.282.693.648.743l.102.007 3.191-.001-3.942-3.944z",
  fill: "#8F90A6"
});

function SvgApprovalDeclined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgApprovalDeclined;